import styled from "styled-components";

export const StatusBadge = styled.span`
  background: #fff;
  color: #000;
  display: inline-block;
  padding: 5px 8px;
  text-align: center;
  border-radius: 20px;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;

  ${({ status }) =>
    status === "ACTIVE" &&
    `
      background: #27dd8b;
      color: #000000;
    `}

  ${({ status }) =>
    status === "IN_PROGRESS" &&
    `
      background: #ffc82c;
      color: #000000;
    `}

  ${({ status }) =>
    status === "SUCCESS" &&
    `
      background: #96ffa8;
      color: #339865;
    `}

  ${({ status }) =>
    status === "NOTICE" &&
    `
      background: #d18cff;
      color: #9900ff;
    `}

  ${({ status }) =>
    status === "FINISHED" &&
    `
      background: #1e1f46;
      color: rgb(255, 255, 255);
    `}

  ${({ status }) =>
    status === "WAITING_FOR_APPROVAL" &&
    `
      background: #1e22ff;
      color: white;
    `}

  ${({ status }) =>
    status === "SCHEDULED" &&
    `
      border: none;
      background: #667efe;
      color: #ffffff;
    `}

  ${({ status }) =>
    status === "ERROR" &&
    `
      background: #ff357f;
      color: #ffffff;
    `}

  ${({ status }) =>
    status === "FULLFILLED" &&
    `
      color: black;
      background: white;
    `}

  ${({ status }) =>
    status === "PREVIEW" &&
    `
      color: white;
      background: blue;
    `}

  ${({ status }) =>
    status === "DRAFT" &&
    `
      background: #c3ffe4;
      color: #000;
    `}

  ${({ status }) =>
    status === "REJECTED" &&
    `
      background: #ff5b3c;
      color: #fff;
    `}

  ${({ status }) =>
    status === "PAUSED" &&
    `
      background: #dceaff;
      color: #000;
    `}

  ${({ status }) =>
    status === "CANCELLED" &&
    `
      background: #ffbcaf;
      color: #000;
    `}
`;
